import { render, staticRenderFns } from "./MembersTable.vue?vue&type=template&id=ca201e16&"
import script from "./MembersTable.vue?vue&type=script&lang=js&"
export * from "./MembersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports